<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-layout align-center justify-center row fill-height title pa-2>
          <mrx-translation :token="'questions.malaria.child_test_id'"></mrx-translation> &nbsp; <v-flex>{{ childTestId }}</v-flex>
        </v-layout>
        <img src="static/images/app/common/malaria_test.png" alt="rdt-test" style="width: 100%"/>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'MalariaAcquireSample',
    model: {
      prop: 'items',
      event: 'click'
    },
    props: {
      'options': Object,
      'items': Array,
      'panelName': String
    },
    data() {
      return {
        childTestId: null
      }
    },
    created() {
      this.childTestId = this.$store.state.settings.malaria_rdt_random_num
      this.items[0].selected = true
    }
  }
</script>

<style scoped>
</style>
